(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  ready(function () {
    document.querySelectorAll('[data-moto-article]').forEach(function (page) {
      var body = page.querySelector('#moto-article-body');
      var toc = page.querySelector('[data-moto-toc]');
      var links = page.querySelector('[data-moto-toc-links]');
      var headings = body ? Array.from(body.querySelectorAll('h2')) : [];

      if (toc && links && headings.length > 1) {
        headings.forEach(function (heading, index) {
          if (!heading.id) heading.id = slugify(heading.textContent) || 'section-' + (index + 1);
          var link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent;
          links.appendChild(link);
        });

        if ('IntersectionObserver' in window) {
          var tocLinks = Array.from(links.querySelectorAll('a'));
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              tocLinks.forEach(function (link) {
                link.toggleAttribute('aria-current', link.getAttribute('href') === '#' + entry.target.id);
              });
            });
          }, { rootMargin: '-18% 0px -68% 0px' });
          headings.forEach(function (heading) { observer.observe(heading); });
        }
      } else if (toc) {
        toc.hidden = true;
      }

      var share = page.querySelector('[data-moto-share]');
      var status = page.querySelector('[data-moto-share-status]');
      if (share) {
        share.addEventListener('click', function () {
          var payload = { title: document.title, url: window.location.href };
          if (navigator.share) {
            navigator.share(payload).catch(function () {});
            return;
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(window.location.href).then(function () {
              share.textContent = 'Link copied';
              if (status) status.textContent = 'Article link copied to clipboard.';
              window.setTimeout(function () {
                share.textContent = 'Share article';
                if (status) status.textContent = '';
              }, 2200);
            });
          }
        });
      }
    });
  });
})();
